import React from 'react';
import { Alert, Link, Typography } from '@one-thd/sui-atomic-components';
import { IPrintLabelError } from '../../models/returns';

const PrintLabelAlerts = ({ error }: { error: IPrintLabelError }) => {
  switch (error.type) {
    case 'TRYAGAIN':
      return (
        <Alert status="error" size="large">
          <Typography variant="body-base">
            We&apos;re sorry. There was a temporary technical error. Please try
            again shortly. If the issue persists, please call Customer Support
            at{' '}
            <Link height="normal" href="tel:1-800-430-3376">
              1-800-430-3376
            </Link>
            .
          </Typography>
        </Alert>
      );
    case 'USED':
      return (
        <Alert status="error" size="large">
          <Typography variant="body-base">
            This shipping label has already been used. Please call Customer
            Support at{' '}
            <Link height="normal" href="tel:1-800-430-3376">
              1-800-430-3376
            </Link>{' '}
            if you have questions or need additional help.
          </Typography>
        </Alert>
      );
    case 'EXPIRED':
      return (
        <Alert status="error" size="large">
          <Typography variant="body-base">
            This shipping label has expired. Please call Customer Support at{' '}
            <Link height="normal" href="tel:1-800-430-3376">
              1-800-430-3376
            </Link>{' '}
            if you have questions or need additional help.
          </Typography>
        </Alert>
      );
    case 'UNKNOWN':
      return (
        <Alert status="error" size="large">
          <Typography variant="body-base">
            We’re sorry. There was a temporary technical error. Please try again
            shortly. If the problem persists, please call Customer Support at{' '}
            <Link height="normal" href="tel:1-800-430-3376">
              1-800-430-3376
            </Link>
            .
          </Typography>
        </Alert>
      );
    case 'TEMPORARY':
      return (
        <Alert status="error" size="large">
          <Typography variant="body-base">
            This shipping label cannot be printed at this time. Please call
            Customer Support at{' '}
            <Link height="normal" href="tel:1-800-430-3376">
              1-800-430-3376
            </Link>{' '}
            if you have questions or need additional help.
          </Typography>
        </Alert>
      );
    case 'SWITCHEDTOPICKUP':
      return (
        <Alert status="error" size="large">
          <Typography variant="body-base">
            This label is no longer valid as the return is set to be picked up
            by UPS. Please call Customer Support at{' '}
            <Link height="normal" href="tel:1-800-430-3376">
              1-800-430-3376
            </Link>{' '}
            if you have questions or need additional help.
          </Typography>
        </Alert>
      );
    default:
      return null;
  }
};

export default PrintLabelAlerts;
